/** The shared card chrome: wordmark + underlined title, and the error banner
 * every card-based screen (login, home, a future /account) shows the same
 * way.
 */

import { h } from "../lib/jsx";

export interface CardHeader {
  el: Element;
  setTitle(title: string): void;
}

export function cardHeader(title: string, wordmarkUrl?: string): CardHeader {
  const titleEl = (<h1 class="otp-title">{title}</h1>) as HTMLElement;
  return {
    el: (
      <header>
        {wordmarkUrl && (
          <img class="otp-wordmark" src={wordmarkUrl} alt="Much Better Adventures" />
        )}
        {titleEl}
      </header>
    ),
    setTitle(next: string) {
      titleEl.textContent = next;
    },
  };
}

export interface ErrorBanner {
  el: Element;
  show(msg?: string): void;
  hide(): void;
}

export function errorBanner(fallback = "Something went wrong. Please try again."): ErrorBanner {
  const el = (<p class="otp-error" role="alert" hidden />) as HTMLElement;
  return {
    el,
    show(msg) {
      el.textContent = msg || fallback;
      el.hidden = false;
    },
    hide() {
      el.hidden = true;
    },
  };
}
